import type { LucideIcon } from "lucide-react";

import { Art, type useOwnPictures } from "./home-pictures";
import classes from "./simple-sections.module.css";

const NOTHING = () => undefined;

export interface TileProps {
  name: string;
  line: string;
  /** The tag over its picture: what it makes. */
  kind: string;
  icon: LucideIcon;
  /** The brand's own pictures of its kind, where it has a kind of its own; else its icon. */
  own?: ReturnType<typeof useOwnPictures> | undefined;
}

/**
 * The inside of the prototype's section tile (`tile`): a 16:10 picture tagged with its kind, its
 * name and its line. The caller wraps it in its link or its Coming soon, with `classes.tile`.
 */
export function TileBody({ name, line, kind, icon, own }: TileProps) {
  return (
    <>
      <span className={classes.tileArt}>
        <Art picture={own?.pictures[0]} icon={icon} onLost={own?.readAgain ?? NOTHING} />
        <span className={classes.tileKind}>{kind}</span>
      </span>
      <b className={classes.tileName}>{name}</b>
      <span className={classes.tileLine}>{line}</span>
    </>
  );
}
